export function VerticalDivider() {
  return (
    <svg
      width="16px"
      height="800px"
      viewBox="0 0 16 800"
      version="1.1"
      xmlns="http://www.w3.org/2000/svg"
      preserveAspectRatio="xMidYMin meet"
      style={{
        inlineSize: "100%",
        blockSize: "max(100svh, 800px)",
      }}
    >
      <g stroke="none" strokeWidth="1.25" fill="none">
        <g
          id="Group"
          transform="translate(3, 359.5)"
          stroke="#593D8F"
          strokeWidth="1.25"
        >
          <line
            x1="-16"
            y1="41.5"
            x2="26"
            y2="41.5"
            id="Line-3"
            strokeLinecap="round"
            strokeDasharray="0.5,4"
            transform="translate(5, 41.5) rotate(-90) translate(-5, -41.5)"
          ></line>
          <g id="Group-7" transform="translate(0, 75)" strokeLinecap="square">
            <line
              x1="2"
              y1="-1"
              x2="8.5"
              y2="8.5"
              id="Line"
              transform="translate(5, 3.5) rotate(-90) translate(-5, -3.5)"
            ></line>
            <line
              x1="2"
              y1="8"
              x2="8.5"
              y2="17.5"
              id="Line"
              transform="translate(5, 12.5) rotate(-90) translate(-5, -12.5)"
            ></line>
            <line
              x1="2"
              y1="17"
              x2="8.5"
              y2="26.5"
              id="Line"
              transform="translate(5, 21.5) rotate(-90) translate(-5, -21.5)"
            ></line>
            <line
              x1="2"
              y1="26"
              x2="8.5"
              y2="35.5"
              id="Line"
              transform="translate(5, 30.5) rotate(-90) translate(-5, -30.5)"
            ></line>
          </g>
          <line
            x1="-46"
            y1="172.5"
            x2="56"
            y2="172.5"
            id="Line-3"
            strokeLinecap="round"
            strokeDasharray="0.5,4"
            transform="translate(5, 172.5) scale(1, -1) rotate(-90) translate(-5, -172.5)"
          ></line>
          <polygon
            id="Triangle"
            strokeLinecap="square"
            transform="translate(5, 3.5) rotate(360) translate(-5, -3.5)"
            points="5 0 8 7 2 7"
          ></polygon>
        </g>
        <g
          id="Group-2"
          transform="translate(4, 0)"
          stroke="#593D8F"
          strokeWidth="1.25"
        >
          <line
            x1="-10"
            y1="266.5"
            x2="19"
            y2="267"
            id="Line-3"
            strokeLinecap="round"
            strokeDasharray="0.5,4"
            transform="translate(4.5, 267) rotate(-90.9878) translate(-4.5, -267)"
          ></line>
          <line
            x1="-57"
            y1="61"
            x2="66"
            y2="61.5"
            id="Line-3"
            strokeLinecap="round"
            strokeDasharray="0.5,4"
            transform="translate(4.5, 61.5) rotate(-90) translate(-4.5, -61.5)"
          ></line>
          <polygon
            id="Triangle"
            strokeLinecap="square"
            transform="translate(4, 134) rotate(180) translate(-4, -134)"
            points="4 130.5 7 137.5 1 137.5"
          ></polygon>
          <circle
            id="Oval"
            strokeLinecap="square"
            cx="4"
            cy="238"
            r="4"
          ></circle>
          <path
            d="M4,224.5 C6.209139,224.5 8,226.290861 8,228.5 L0,228.5 C0,226.290861 1.790861,224.5 4,224.5 Z"
            id="Path"
            strokeLinecap="square"
          ></path>
        </g>
        <g
          id="Group-2"
          transform="translate(4, 1718)"
          stroke="#593D8F"
          strokeWidth="1.25"
        >
          <line
            x1="-10"
            y1="266.5"
            x2="19"
            y2="267"
            id="Line-3"
            strokeLinecap="round"
            strokeDasharray="0.5,4"
            transform="translate(4.5, 267) rotate(-90.9878) translate(-4.5, -267)"
          ></line>
          <line
            x1="-57"
            y1="61"
            x2="66"
            y2="61.5"
            id="Line-3"
            strokeLinecap="round"
            strokeDasharray="0.5,4"
            transform="translate(4.5, 61.5) rotate(-90) translate(-4.5, -61.5)"
          ></line>
          <polygon
            id="Triangle"
            strokeLinecap="square"
            transform="translate(4, 134) rotate(180) translate(-4, -134)"
            points="4 130.5 7 137.5 1 137.5"
          ></polygon>
          <circle
            id="Oval"
            strokeLinecap="square"
            cx="4"
            cy="238"
            r="4"
          ></circle>
          <path
            d="M4,224.5 C6.209139,224.5 8,226.290861 8,228.5 L0,228.5 C0,226.290861 1.790861,224.5 4,224.5 Z"
            id="Path"
            strokeLinecap="square"
          ></path>
        </g>
        <line
          x1="-13"
          y1="1176.5"
          x2="29"
          y2="1176.5"
          id="Line-3"
          stroke="#593D8F"
          strokeWidth="1.25"
          strokeLinecap="round"
          strokeDasharray="0.5,4"
          transform="translate(8, 1176.5) rotate(-90) translate(-8, -1176.5)"
        ></line>
        <g
          id="Group-7"
          transform="translate(3, 1209.5)"
          stroke="#593D8F"
          strokeLinecap="square"
          strokeWidth="1.25"
        >
          <line
            x1="2"
            y1="-1"
            x2="8.5"
            y2="8.5"
            id="Line"
            transform="translate(5, 3.5) rotate(-90) translate(-5, -3.5)"
          ></line>
          <line
            x1="2"
            y1="8"
            x2="8.5"
            y2="17.5"
            id="Line"
            transform="translate(5, 12.5) rotate(-90) translate(-5, -12.5)"
          ></line>
          <line
            x1="2"
            y1="17"
            x2="8.5"
            y2="26.5"
            id="Line"
            transform="translate(5, 21.5) rotate(-90) translate(-5, -21.5)"
          ></line>
          <line
            x1="2"
            y1="26"
            x2="8.5"
            y2="35.5"
            id="Line"
            transform="translate(5, 30.5) rotate(-90) translate(-5, -30.5)"
          ></line>
        </g>
        <g
          id="Group-7"
          transform="translate(3, 828.5)"
          stroke="#593D8F"
          strokeLinecap="square"
          strokeWidth="1.25"
        >
          <line
            x1="2"
            y1="-1"
            x2="8.5"
            y2="8.5"
            id="Line"
            transform="translate(5, 3.5) rotate(-90) translate(-5, -3.5)"
          ></line>
          <line
            x1="2"
            y1="8"
            x2="8.5"
            y2="17.5"
            id="Line"
            transform="translate(5, 12.5) rotate(-90) translate(-5, -12.5)"
          ></line>
          <line
            x1="2"
            y1="17"
            x2="8.5"
            y2="26.5"
            id="Line"
            transform="translate(5, 21.5) rotate(-90) translate(-5, -21.5)"
          ></line>
          <line
            x1="2"
            y1="26"
            x2="8.5"
            y2="35.5"
            id="Line"
            transform="translate(5, 30.5) rotate(-90) translate(-5, -30.5)"
          ></line>
        </g>
        <line
          x1="-43"
          y1="1307.5"
          x2="59"
          y2="1307.5"
          id="Line-3"
          stroke="#593D8F"
          strokeWidth="1.25"
          strokeLinecap="round"
          strokeDasharray="0.5,4"
          transform="translate(8, 1307.5) scale(1, -1) rotate(-90) translate(-8, -1307.5)"
        ></line>
        <line
          x1="-34"
          y1="772"
          x2="50.5"
          y2="771.5"
          id="Line-3"
          stroke="#593D8F"
          strokeWidth="1.25"
          strokeLinecap="round"
          strokeDasharray="0.5,4"
          transform="translate(8.5, 772) rotate(-90) translate(-8.5, -772)"
        ></line>
        <line
          x1="-34"
          y1="1507"
          x2="50"
          y2="1506.5"
          id="Line-3"
          stroke="#593D8F"
          strokeWidth="1.25"
          strokeLinecap="round"
          strokeDasharray="0.5,4"
          transform="translate(8, 1507) rotate(-90) translate(-8, -1507)"
        ></line>
        <line
          x1="-34"
          y1="1047"
          x2="50"
          y2="1046.5"
          id="Line-3"
          stroke="#593D8F"
          strokeWidth="1.25"
          strokeLinecap="round"
          strokeDasharray="0.5,4"
          transform="translate(8, 1047) rotate(-90) translate(-8, -1047)"
        ></line>
        <line
          x1="-7"
          y1="938"
          x2="23"
          y2="938"
          id="Line-3"
          stroke="#593D8F"
          strokeWidth="1.25"
          strokeLinecap="round"
          strokeDasharray="0.5,4"
          transform="translate(8, 938) rotate(-90) translate(-8, -938)"
        ></line>
        <circle
          id="Oval"
          stroke="#593D8F"
          strokeWidth="1.25"
          strokeLinecap="square"
          cx="8"
          cy="600.5"
          r="4"
        ></circle>
        <circle
          id="Oval"
          stroke="#593D8F"
          strokeWidth="1.25"
          strokeLinecap="square"
          cx="8"
          cy="1375.5"
          r="4"
        ></circle>
        <circle
          id="Oval"
          stroke="#593D8F"
          strokeWidth="1.25"
          strokeLinecap="square"
          cx="8"
          cy="615.5"
          r="4"
        ></circle>
        <circle
          id="Oval"
          stroke="#593D8F"
          strokeWidth="1.25"
          strokeLinecap="square"
          cx="8"
          cy="1390.5"
          r="4"
        ></circle>
        <circle
          id="Oval"
          stroke="#593D8F"
          strokeWidth="1.25"
          strokeLinecap="square"
          cx="8"
          cy="721"
          r="4"
        ></circle>
        <circle
          id="Oval"
          stroke="#593D8F"
          strokeWidth="1.25"
          strokeLinecap="square"
          cx="8"
          cy="1455.5"
          r="4"
        ></circle>
        <circle
          id="Oval"
          stroke="#593D8F"
          strokeWidth="1.25"
          strokeLinecap="square"
          cx="8"
          cy="980.5"
          r="4"
        ></circle>
        <path
          d="M8,707.5 C10.209139,707.5 12,709.290861 12,711.5 L4,711.5 C4,709.290861 5.790861,707.5 8,707.5 Z"
          id="Path"
          stroke="#593D8F"
          strokeWidth="1.25"
          strokeLinecap="square"
        ></path>
        <path
          d="M8,1442.5 C10.209139,1442.5 12,1444.29086 12,1446.5 L4,1446.5 C4,1444.29086 5.790861,1442.5 8,1442.5 Z"
          id="Path"
          stroke="#593D8F"
          strokeWidth="1.25"
          strokeLinecap="square"
        ></path>
        <path
          d="M8,967.5 C10.209139,967.5 12,969.290861 12,971.5 L4,971.5 C4,969.290861 5.790861,967.5 8,967.5 Z"
          id="Path"
          stroke="#593D8F"
          strokeWidth="1.25"
          strokeLinecap="square"
        ></path>
        <path
          d="M8,989.5 C10.209139,989.5 12,991.290861 12,993.5 L4,993.5 C4,991.290861 5.790861,989.5 8,989.5 Z"
          id="Path"
          stroke="#593D8F"
          strokeWidth="1.25"
          strokeLinecap="square"
          transform="translate(8, 991.5) rotate(180) translate(-8, -991.5)"
        ></path>
        <g
          id="Group-7"
          transform="translate(3, 1563.5)"
          stroke="#593D8F"
          strokeLinecap="square"
          strokeWidth="1.25"
        >
          <line
            x1="2"
            y1="-1"
            x2="8.5"
            y2="8.5"
            id="Line"
            transform="translate(5, 3.5) rotate(-90) translate(-5, -3.5)"
          ></line>
          <line
            x1="2"
            y1="8"
            x2="8.5"
            y2="17.5"
            id="Line"
            transform="translate(5, 12.5) rotate(-90) translate(-5, -12.5)"
          ></line>
          <line
            x1="2"
            y1="17"
            x2="8.5"
            y2="26.5"
            id="Line"
            transform="translate(5, 21.5) rotate(-90) translate(-5, -21.5)"
          ></line>
          <line
            x1="2"
            y1="26"
            x2="8.5"
            y2="35.5"
            id="Line"
            transform="translate(5, 30.5) rotate(-90) translate(-5, -30.5)"
          ></line>
        </g>
      </g>
    </svg>
  );
}
